import LocalizedStrings from 'localized-strings';

import { TeamMemberTransitionDisabledReason } from '__generated__/GQL';

type DisabledReason = `${TeamMemberTransitionDisabledReason}`;

const locales = new LocalizedStrings({
  en: {
    disabled: 'Disabled',
    short: {
      ALREADY_HAS_ROLE:
        'It is impossible to reassign the same role to the user',
      BENEFICIARY_ONLY_TRANSITION:
        'This role is reserved for legal beneficiaries',
      CANNOT_SELF_EDIT: 'You cannot change your own role',
      KYC_NOT_VALIDATED: "This user's KYC is incomplete",
      PENDING_INVITATION:
        "Invitation in progress, it is impossible to modify the user's role until the invitation is completed",
      PERMISSION_TOO_LOW: 'You do not have the necessary permissions',
    } satisfies Record<DisabledReason, string>,
  },
  fr: {
    disabled: 'Désactivé',
    short: {
      ALREADY_HAS_ROLE:
        "Il est impossible de réaffecter le même rôle à l'utilisateur",
      BENEFICIARY_ONLY_TRANSITION:
        'Ce rôle est réservé aux bénéficiaires légaux',
      CANNOT_SELF_EDIT: 'Vous ne pouvez pas modifier votre propre rôle',
      KYC_NOT_VALIDATED: 'Le KYC de cet utilisateur est incomplet',
      PENDING_INVITATION:
        "Invitation en cours, il est impossible de modifier le rôle de l'utilisateur tant que l'invitation n'est pas complétée",
      PERMISSION_TOO_LOW: 'Vous ne disposez pas des permissions nécessaires',
    } satisfies Record<DisabledReason, string>,
  },
} as const);

export default locales;
